export const initialState = {
  loading: false,
  success: false
};

export type ResendState = typeof initialState;

type ResendAction =
  | { type: 'RESEND_REQUEST' }
  | { type: 'RESEND_SUCCESS' }
  | { type: 'RESEND_RESET' };

export const resendReducer = (state: ResendState, action: ResendAction): ResendState => {
  switch (action.type) {
    case 'RESEND_REQUEST':
      return { loading: true, success: false };
    case 'RESEND_SUCCESS':
      return { loading: false, success: true };
    case 'RESEND_RESET':
      return { loading: false, success: false };
    default:
      return state;
  }
};
